module.exports = __webpack_public_path__ + "img/email.69dfe6ca.svg";